'use client';
import { tailwindDesignSystemTheme as r } from "../config/theme.config.js";
import { useMediaQuery as i } from "./use-media-query.js";
function a() {
  const e = r.theme.extend.screens, t = i(`(max-width: ${e.sm})`), s = i(`(min-width: ${e.sm})`), n = i(`(min-width: ${e.md})`), m = i(`(min-width: ${e.lg})`), o = i(`(min-width: ${e.xl})`);
  return {
    isMobile: t,
    isTablet: s,
    isLargeTablet: n,
    isDesktop: m,
    isLargeScreen: o
  };
}
export {
  a as useScreenSize
};
